import Vue from 'vue'
import Vuex from 'vuex'

import * as types from './mutation-types'

import JWT from '@/tools/jwt'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export const AUTH_TOKEN_KEY = 'WFC_AUTH_TOKEN'

export const AUTH_PAYLOAD_KEY = 'JCMS_CURRENT_USER'

export const state = {
  token: Cookies.get('WFC_AUTH_TOKEN'),
  payload: window.localStorage.getItem(AUTH_PAYLOAD_KEY),
  noticeNum: 0,
  loading: false
}

export const getters = {
  isLoading: state => {
    return state.loading
  },
  token: state => {
    return state.token
  },
  payload: state => {
    let payload = window.localStorage.getItem(AUTH_PAYLOAD_KEY)
    return JSON.parse(payload)
  },
  // 当前登录用户
  currentUser: state => {
    return JWT.payload(state.token) || {}
  },
  // 用户登录状态
  isLoggedin: state => {
    return JWT.payload(state.token)
  },
  noticeNum: state => {
    return state.noticeNum
  }
}

export const actions = {
  // 加载状态
  setLoading({ commit }, status) {
    commit(types.SET_LOADING, status)
  },
  //, 保存 token
  saveToken({ commit }, { token }) {
    commit(types.CLEAR_TOKEN)

    if (JWT.valid(token)) {
      commit(types.SAVE_TOKEN, { token: token })
      return true
    } else {
      return false
    }
  },
  savePayload({ commit }, { payload }) {
    commit(types.SAVE_PAYLOAD, { payload: payload })
  },
  clearToken({ commit }) {
    commit(types.CLEAR_TOKEN)
  },
  // 退出登录
  doLogout({ commit }) {
    commit(types.CLEAR_TOKEN)
  },
  setNoticeNumber({ commit }, num) {
    commit(types.SET_NOTICE_NUM, num)
  }
}

export const mutations = {
  [types.SET_LOADING](state, status) {
    state.loading = status || false
  },
  // 清空 auth token
  [types.CLEAR_TOKEN](state) {
    Cookies.remove(AUTH_TOKEN_KEY, { path: '/' })
    state.token = null
  },
  // 保存 token 到本地
  [types.SAVE_TOKEN](state, { token }) {
    if (token !== state.token) {
      Cookies.set(AUTH_TOKEN_KEY, token)
      state.token = token
      state.currentUser = JWT.payload(state.token)
    }
  },
  // 保存 当前用户 到本地
  [types.SAVE_PAYLOAD](state, { payload }) {
    if (payload !== state.payload) {
      window.localStorage.setItem(AUTH_PAYLOAD_KEY, JSON.stringify(payload))
      state.payload = payload
    }
  },
  [types.SET_NOTICE_NUM](state, num) {
    state.noticeNum = num
  }
}

export default new Vuex.Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
})